module.exports = global["jQuery"] = require("-!/data/www/mathesio/html/webapp/node_modules/expose-loader/index.js?$!/data/www/mathesio/html/webapp/node_modules/imports-loader/index.js?global=>window,this=>window!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ../~/jquery/dist/jquery.js
// module id = 84
// module chunks = 1